import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';

import YumurtlamaImg from '../../assets/donduraraksaklama.jpeg';
import AsrmEshre from '../../components/asrmEshre';

export function DondurarakSaklama() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="dondurarak saklama" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="dondurarak saklama" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="image-wrapper">
            <img src={YumurtlamaImg} alt="Dondurarak Saklama" />
          </div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <h3><TranslateStatic string="dondurarakSaklamaH1" /></h3>
            <p>
              <TranslateStatic string="dondurarakSaklamaP2" />
            </p>
            <ul>
              <li><TranslateStatic string="dondurarakLi1" /></li>
              <li><TranslateStatic string="dondurarakLi2" /></li>
              <li><TranslateStatic string="dondurarakLi3" /></li>
              <li><TranslateStatic string="dondurarakLi4" /></li>
            </ul>

            <h3><TranslateStatic string="dondurarakSaklamaH2" /></h3>
            <p>
              <TranslateStatic string="dondurarakSaklamaP3" />
            </p>
            <p>
              <TranslateStatic string="dondurarakSaklamaP3-1" />
            </p>
            <ul>
              <li><TranslateStatic string="dondurarakLi5" /></li>
              <li><TranslateStatic string="dondurarakLi6" /></li>
              <li><TranslateStatic string="dondurarakLi7" /></li>
            </ul>
            <p>
              <TranslateStatic string="dondurarakSaklamaP6" />
            </p>
            <p>
              <b><TranslateStatic string="dondurBold" /></b>
            </p>

            <h3><TranslateStatic string="dondurarakSaklamaH3" /></h3>
            <p>
              <TranslateStatic string="dondurarakSaklamaP4" />
            </p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
